import { isEmpty } from 'lodash';

import * as FilterTypes from '../constants/FilterTypes';

export const getSelectedFiltersCount = (filters, values) => {
  if (!filters || !values) {
    return 0;
  }

  let total = 0;

  filters.top.forEach((filter) => {
    if (isFilterSelected(filter, values)) {
      total++;
    }
  });
  filters.overlay.forEach((block) => {
    block.filters.forEach((filter) => {
      if (isFilterSelected(filter, values)) {
        total++;
      }
    });
  });

  return total;
};

const isFilterSelected = (filter, values) => {
  switch (filter.type) {
    case FilterTypes.KEYWORK:
    case FilterTypes.FREE_TEXT:
    case FilterTypes.CHECKBOX:
    case FilterTypes.EDUCATIONS_YEAR_FROM:
    case FilterTypes.EDUCATIONS_YEAR_TO:
    case FilterTypes.SELECT_WITH_SEARCH_AND_OTHER_OPTIONS:
      return values.query[filter.name];
    case FilterTypes.NUMBER_RANGE:
    case FilterTypes.DECIMAL_RANGE:
    case FilterTypes.YEAR_RANGE:
      return (
        !!values.query[`min_${filter.name}`] ||
        values.query[`min_${filter.name}`] === 0 ||
        !!values.query[`max_${filter.name}`] ||
        values.query[`max_${filter.name}`] === 0
      );
    case FilterTypes.DATE_RANGE:
      return (
        values.query[`min_${filter.name}`] || values.query[`max_${filter.name}`]
      );
    case FilterTypes.LOCATION:
      // Not scalable, we need to handle the location under a real key and use the name of this key, not put it hardcoded at the root of values
      return (
        values.query.online || !!values.query.lat || values.query.lat === 0
      );
    case FilterTypes.BOOLEAN:
      return (
        values.query[filter.name] === '0' || values.query[filter.name] === '1'
      );
    case FilterTypes.SELECT:
    case FilterTypes.FULLTEXT_SELECT:
    case FilterTypes.INDUSTRIES:
    case FilterTypes.SKILLS:
    case FilterTypes.NATIONALITIES:
    case FilterTypes.SUB_NETWORKS:
    case FilterTypes.COMPANIES:
    case FilterTypes.SCHOOLS:
    case FilterTypes.FIELD_OF_STUDIES:
    case FilterTypes.DEGREES:
      return !isEmpty(values.query[filter.name]);
    case FilterTypes.DOUBLE_SELECT:
      return (
        values.query[filter.name]?.root_value ||
        !isEmpty(values.query[filter.name].child_value)
      );
    default:
      return false;
  }
};
